import { httpService } from "./http.service";
import store from "../store/index";
// import { indexedDBStorage } from './indexedDb.service'

export const authService = {
  firstFactorAuth,
  sendAgainOtpCode,
  secondFactorAuth,
  logout,

  getLoggedInUser,
  // getSessionToken,
};

// const url = window.location.host
// url.includes('localhost') || url.includes('apoint.co.il')
// 	? 'CE018122-CA81-4EEF-B60E-5D9F9D97A48F' //to do: change to compID of the sayeret
// 	: '79D4854D-F78C-4940-87BC-834CCB96ED8C'

const AppGuid = "AFAE349F-432C-4485-8FE8-B90BE37AE678";
// const STORAGE_KEY_LOGGEDIN_USER = 'user_db'
// const STORAGE_KEY_SESSION_TOKEN = 'session_token'

const APP_ID = 2;
const withPrefix = false;

async function firstFactorAuth(userName, pswd, compId, sendType) {
  const body = {
    idParam1: userName,
    idParam2: pswd,
    compID: compId,
    appId: APP_ID,
    appGuid: AppGuid,
    otpPreferredSendMethod: sendType,
  };
  console.log(withPrefix);
  const res = await httpService.post("/auth/otp/start", body, withPrefix);

  if (res.codeSent) {
    return res.sendTo;
  }
}
async function sendAgainOtpCode(otpGuid) {
  const body = {
    otpGuid: otpGuid,
  };
  const res = await httpService.post("/auth/otp/send", body, withPrefix);

  if (res.codeSent) {
    return res.sendTo;
  }
}

async function secondFactorAuth(otpCode, otpGuid) {
  const body = {
    otpGuid: otpGuid,
    otpCode: otpCode,
    saveSessionTokenInHttpCookie: false,
  };

  const  userData = await httpService.post(
    "/auth/otp/auth",
    body,
    withPrefix
  );
  store.commit("api/setSessionData", {
    sessionToken: userData.sessionToken,
});
  if (userData) {
    saveLocalUser(userData);
    return userData;
  }
}

async function logout() {
  // indexedDBStorage.remove(STORAGE_KEY_LOGGEDIN_USER)
  return await httpService.post("/auth/logout", null, withPrefix);
}

function saveLocalUser(user) {
  // indexedDBStorage.set(STORAGE_KEY_LOGGEDIN_USER, user)
  // indexedDBStorage.set(STORAGE_KEY_SESSION_TOKEN, user.sessionToken)

  return user;
}

async function getLoggedInUser() {
  // return await indexedDBStorage.get(STORAGE_KEY_LOGGEDIN_USER)
}

// async function getSessionToken() {
//     return (await indexedDBStorage.get(STORAGE_KEY_SESSION_TOKEN)) || null
// }
